import React from 'react'
import { useTranslation } from '@mc/i18n'
import styles from './CampModuleNumber.module.scss'

interface ModuleNumberProps {
  moduleNumber: number
}

export const CampModuleNumber = ({ moduleNumber }: ModuleNumberProps) => {
  const { t } = useTranslation('@mc/next')

  return (
    <span className={styles.moduleNumber}>
      <span className='mc-sr-only'>
        {t('sessions.curriculum.moduleNumberSr', {
          number: moduleNumber,
        })}
      </span>

      <span aria-hidden>{moduleNumber}</span>
    </span>
  )
}
